export default function processAddressPath(path?: string, type?: string) {
	return path ? `,${type || ""} ${path}`.trim() : "";
}
